import { z } from 'zod';
import { BillingInterval, PlanId, PlanLimits, SelfServePlan, TaxMode } from './plans.js';

export const BillingCheckoutInput = z.object({ plan: SelfServePlan, interval: BillingInterval }).strict();
export type BillingCheckoutInput = z.infer<typeof BillingCheckoutInput>;
export const BillingPlan = z.object({
  plan: SelfServePlan,
  interval: BillingInterval,
  /** Cents, excl. VAT. */
  amount: z.number().int().positive(),
  currency: z.literal('eur'),
});
export type BillingPlan = z.infer<typeof BillingPlan>;
export const BillingPlansDto = z.object({
  enabled: z.boolean(),
  registration: z.boolean(),
  taxMode: TaxMode,
  plans: z.array(BillingPlan),
});
export const BillingDto = z.object({
  hostedInvoiceUrl: z.string().url().nullable().optional(),
  enabled: z.boolean(),
  hasAccess: z.boolean(),
  exempt: z.boolean(),
  status: z.string(),
  plan: PlanId.nullable(),
  interval: BillingInterval.nullable(),
  /** Effective limits of the billing account; `null` = unlimited (exempt). */
  limits: PlanLimits.nullable(),
  /** Companies covered by the same billing account (this one included). */
  companiesUsed: z.number().int().nonnegative(),
  /** Usage of the other limits across the account (runs: this quota period); null when unlimited. */
  usage: z
    .object({
      agents: z.number().int().nonnegative(),
      seats: z.number().int().nonnegative(),
      runsPerMonth: z.number().int().nonnegative(),
      sandboxHours: z.number().nonnegative(),
      periodEnd: z.string(),
    })
    .nullable(),
  trialStart: z.string().nullable(),
  trialEnd: z.string().nullable(),
  paidThrough: z.string().nullable(),
  cancelAtPeriodEnd: z.boolean(),
  /** Owner of this company AND of its billing account (another owner sees the status read-only). */
  canManage: z.boolean(),
});
export type BillingDto = z.infer<typeof BillingDto>;
export type BillingPlansDto = z.infer<typeof BillingPlansDto>;
export const BillingRedirectDto = z.object({ url: z.string().url() });
